import i18next from 'i18next'
import {FC, useEffect, useMemo, useState} from 'react'
import {Col, Form, InputGroup, Row} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import {formatCurrency} from 'src/utils/formatCurrency'

interface Props {}

export const InputQuantumSO: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const defaultValue = useMemo(() => orderItem?.quantity ?? '', [orderItem])
  const productType = useMemo(() => orderItem?.product_type ?? '', [orderItem])
  const productUnit = useMemo(() => orderItem?.unit ?? '', [orderItem])
  const sectorId = useMemo(() => orderItem?.sector_id ?? '', [orderItem])

  const handleChange = (value: string) => {
    // dispatch(setSoItem({...soItem, quantity: formatCurrency(value, i18next.language)}))
    dispatch(setSoItem({...soItem, quantity: value}))
  }

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>
          {productType == '8105' ? t('sack') : t('sub-order-kuantum') + ' SO'}
        </Form.Label>
      </Col>
      <Col md={8}>
        <InputGroup size='sm'>
          <CurrencyInput
            className='form-control form-control-sm'
            placeholder={productType == '8105' ? t('sack') : t('sub-order-kuantum')}
            defaultValue={defaultValue}
            decimalSeparator={i18next.language === 'en' ? '.' : ','}
            groupSeparator={i18next.language === 'en' ? ',' : '.'}
            decimalsLimit={3}
            onValueChange={(value: any) => handleChange(value as string)}
          />
          <InputGroup.Text id='basic-addon2'>
            {productType == '8105' ? productUnit : sectorId === 3 ? ' MT' : ' Ton'}
          </InputGroup.Text>
        </InputGroup>
      </Col>
    </Row>
  )
}
